<template>
  <div id="app">    <div class="gap">
      <nav v-if="user" class="navbar navbar-expand-lg bg-secondary fixed-top text-uppercase " id="mainNav">
        <div class="container">
          <router-link class="navbar-brand js-scroll-trigger" :to="{ name: 'Home' }">
            <img src="./assets/logo_kibon.png" class="img-top" alt="">
          </router-link>
          <button class="navbar-toggler navbar-toggler-right text-uppercase bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Menu
            <i class="fas fa-bars"></i>
          </button>
          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item mx-0 mx-lg-1"> 
                <router-link class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" :to="{ name: 'ListPessoas' }">Pessoas</router-link> 
              </li>
              <li class="nav-item mx-0 mx-lg-1"> 
                <router-link class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" :to="{ name: 'ListEquipamento' }">Equipamentos</router-link> 
              </li>
<!--<li class="nav-item mx-0 mx-lg-1"> 
                <router-link class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" :to="{ name: 'CadUser' }">Usuários</router-link> 
              </li>-->
            </ul>
            <a href="#" v-on:click="logout"><i class="fa fa-sign-out-alt" aria-hidden="true"></i></a> 
          </div>
        </div>
      </nav>
    </div>
    <div class="rview">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
require ("../node_modules/jquery/dist/jquery.js");
require ("../node_modules/popper.js/dist/popper.js");
require ("../node_modules/bootstrap/dist/js/bootstrap.js");
const fb = require('./config/db.js')
export default {
  name: 'app',
  data(){
    return {
      user: ''
    }
  },
  created(){
    this.user = fb.auth.currentUser;
  },
  updated(){
    this.user = fb.auth.currentUser;
  },
  methods: {
    logout(){
      if (confirm("Deseja realmente sair?"))
        fb.auth.signOut().then(() => {
          this.$router.replace('/login')
        });
    }
  }
}
</script>

<style lang="css">
  @import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
  @import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
</style>

<style scoped>
  .rview{
    margin-top: 9%;
  }
  .img-top {
    max-width:60%;
    height:auto;

  }
  .navbar-brand {
    padding: 0 !important;
    margin: 0 !important;
  }
  .bg-secondary {
    background-color: white !important;
    background-image: linear-gradient(to right, white, white,white,  rgba(250,0,0,1), rgba(230,0,0,1),  rgba(210,0,0,1), rgba(190,0,0,1),  rgba(170,0,0,1), rgba(150,0,0,1));
  }
  .nav-link {
    color: white;
  }
</style>
